<nexweb-button
  (clicked)="fileClickHandler()"
  [disabled]="file.size <= 0"
  [fillMode]="fillMode"
  [icon]="icon"
  [title]="fileLabel"></nexweb-button>
